
import { defineComponent } from "vue";
import api, { SecurityEvent } from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  event: SecurityEvent;
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsySecurityEventForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetSecurityEvent();
    });
  },
  data: (): State => {
    let securityevent = { } as SecurityEvent;
    return {
      msg: "Sheqsy Event",
      event: securityevent,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    switchAbbrTitle() {
      const templateTags = document.getElementsByTagName('abbr')
      if (templateTags.length < 1) {
        return;        
      }
      for (let elem of templateTags) {
        const title = elem.title;
        const text = elem.textContent || ''
        elem.title = text;
        elem.textContent = title;
        elem.classList.toggle('text-nowrap')
      }
    },
    callGetSecurityEvent() {

      let event_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      event_id = this.$route.params.slug
      this.errors = [];

      api
        .getSecurityEvent(event_id)
        .then((response) => {
          this.event = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
